/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Linguistics16Inputs */

const en__field_enum_icsrm_linguistics16 = /** @type {(inputs: _Field_Enum_Icsrm_Linguistics16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linguistics & Cultural Science`)
};

const de__field_enum_icsrm_linguistics16 = /** @type {(inputs: _Field_Enum_Icsrm_Linguistics16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linguistik & Kulturwissenschaften`)
};

/**
* | output |
* | --- |
* | "Linguistics & Cultural Science" |
*
* @param {_Field_Enum_Icsrm_Linguistics16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_linguistics16 = /** @type {((inputs?: _Field_Enum_Icsrm_Linguistics16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Linguistics16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_linguistics16(inputs)
	return de__field_enum_icsrm_linguistics16(inputs)
});
export { _field_enum_icsrm_linguistics16 as "_field_enum_ICSRM_LINGUISTICS" }